// Extract a human-readable error string from an axios/fetch error.
// FastAPI returns 4xx with `{ detail: "..." }`; pydantic 422 returns an
// array; slowapi rate-limit returns `{ error: "5 per 1 hour" }`; gateway
// failures (502/504) often return HTML with no parseable body.
export function apiErrorMessage(err, fallback = 'Something went wrong') {
  if (!err) return fallback;
  const resp = err.response;
  // Network / CORS — no response at all.
  if (!resp) return err.message || 'Network error. Check your connection and try again.';
  const data = resp.data;
  if (data) {
    // FastAPI HTTPException
    if (typeof data.detail === 'string' && data.detail.trim()) return data.detail.trim();
    // Pydantic validation error: detail is an array of {msg, loc, ...}
    if (Array.isArray(data.detail) && data.detail.length) {
      const msgs = data.detail.map((d) => d?.msg).filter(Boolean);
      if (msgs.length) return msgs.join('; ');
    }
    // slowapi rate-limit handler
    if (typeof data.error === 'string' && data.error.trim()) {
      return `Rate limit reached (${data.error.trim()}). Please wait and try again.`;
    }
    if (typeof data.message === 'string' && data.message.trim()) return data.message.trim();
  }
  // Status-code-only fallback so users still see something useful.
  if (resp.status === 429) return 'Too many attempts. Please wait an hour and try again.';
  if (resp.status === 502 || resp.status === 503 || resp.status === 504) {
    return 'Service is temporarily unavailable. Please try again shortly.';
  }
  return fallback;
}
